import React, { Component } from "react";
import { ContentPageContext } from "../context";
import {
  ContentPageItem,
  ContentPageItemCollection,
} from "services/entities/content";
import FAQ, { FAQItem } from "components/FAQ";
import ProgressSpinner from "components/ProgressSpinner";
import "./index.scss";

interface ContentFAQProps {
  code: string;
  allExpanded?: boolean;
  sectionTitle?: string;
}

export default class ContentFAQ extends Component<ContentFAQProps, any> {
  static contextType = ContentPageContext;

  shouldComponentUpdate(
    nextProps: Readonly<ContentFAQProps>,
    nextState: Readonly<{}>,
    nextContext: any
  ): boolean {
    return this.props.code !== nextProps.code || nextContext !== this.context;
  }

  render() {
    const faqItems: ContentPageItem[] | null = this.context
      ? this.context.items[this.props.code] || null
      : null;
    if (!faqItems) {
      return (
        this.props.children || (
          <div className="content-faq empty">
            <ProgressSpinner />
          </div>
        )
      );
    } else {
      return (
        <FAQ
          sectionTitle={this.props.sectionTitle}
          items={faqItems.map(ContentFAQ.contentItemToFAQItem)}
          allExpanded={this.props.allExpanded}
        />
      );
    }
  }

  static contentItemToFAQItem(item: ContentPageItem): FAQItem {
    const itemCollection = item as ContentPageItemCollection;
    return {
      question: (itemCollection["question"] as string | undefined) || "",
      answer: (itemCollection["answer"] as string | undefined) || "",
    };
  }
}
